import { axios } from 'Lib/axios'
import { useQuery } from '@tanstack/react-query'
import { ExtractFnReturnType } from 'Lib/react-query'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { Plan } from '../types/Plan'

type QueryFnType = typeof getPlans

type PlansResponse = {
  products: Plan[]
}

export const useGetPlans = (enabled?: boolean) => {
  const { accountId } = useUserStore()
  const isEnabled = enabled === undefined ? true : enabled
  const query = useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['plans', accountId],
    queryFn: () => getPlans(accountId),
    enabled: isEnabled,
  })

  const data = query.data && query.data instanceof Error ? undefined : query.data
  return { ...query, data }
}

const getPlans = (accountId: number): Promise<Plan[] | Error> => {
  return axios
    .get<{ data: PlansResponse }>(`accounts/${accountId}/subscriptions/packages`)
    .then((res) => {
      return res.data.data.products
    })
    .catch((e) => {
      return e as Error
    })
}
